import Store from '@wetransfer/transfer/store';
import Actions from '@wetransfer/transfer/store/action';

export function getElementPosition(el: HTMLElement): {
  x: number;
  y: number;
  width: number;
  height: number;
} {
  if (el) {
    const rect = el.getBoundingClientRect();

    return {
      x: Math.round(rect.left),
      y: Math.round(rect.top),
      width: Math.round(rect.width),
      height: Math.round(rect.height),
    };
  }

  return { x: 0, y: 0, width: 0, height: 0 };
}

export const getNavPosition = () =>
  getElementPosition(document.querySelector('.nav'));

export const getTransferBoxPosition = () =>
  getElementPosition(
    document.querySelector('.transfer') ||
      document.getElementById('transfer-pro')
  );

export const showApp = () => {
  Store.dispatch(Actions.Layout.showUI());
};

export const hideApp = () => {
  Store.dispatch(Actions.Layout.hideUI());
};

export const showDropzone = () => {
  const state = Store.getState();

  if (!state.layout.dropzoneActive && state.session.tandc) {
    Store.dispatch(Actions.Layout.setDropZoneState(true));
  }
};
